import store from "../../store/store"
import ToggleItem from "./toggle_item/toggle_item"
import('./config_modal.css')

export default function ConfigModal(opts={}){
    BaseConstructor.call(this)
    let {container} = opts
    let elements = {}
    let context = this
    let modal_id = '#modal_general_config'

    let toggleItemName, toggleItemMaxMin

    this.generate = () =>{
        
    }

    this.update = () =>{

    }

    this.showModal = _ =>{
        $(modal_id).modal('show')
    }

    this.hideModal = _ =>{
        $(modal_id).modal('hide')
    }

    init()

    function init(){
        elements.modal_title = context.createElement('div', 'config-modal-group-title', 'Configurações Gerais')
        elements.modal_title_visualization = context.createElement('div', 'config-modal-group-title', '')
        elements.general_config = context.createElement('div', 'mt-3 mb-3', '')
        elements.visualization_config = context.createElement('div', 'mt-3', '')
        
        toggleItemName = createToggleItem('show_station_name','nome dos postos', 'Exibir nome de cada posto do diagrama') 
        toggleItemName.generate()

        toggleItemMaxMin = createToggleItem('show_max_min', 'Exibir valor máximo e mínimo','Exibir valores máximos e mínimos do período') 
        toggleItemMaxMin.generate()

        $(modal_id).find('.modal-body').append(elements.modal_title, elements.general_config, elements.modal_title_visualization, elements.visualization_config)
        eventsHandler()
    }

    function createToggleItem(id, title,desc){
        return new ToggleItem({container:elements.general_config, title: title, desc: desc,id:id})
    }

    function eventsHandler(){
        store.mainConfigStore.subscribe('SET_MODAL_CONFIG_VISIBILITY', boolean=>{
            if(boolean){
                context.showModal()
            } else {
                context.hideModal()
            }
        })
    }
}

ConfigModal.prototype = Object.create(BaseConstructor.prototype)